export const homeHeader = {
  title: {
    part2: ' vacantes esperándote en ',
  },
}
